enum GenderType {
  NOT_KNOWN = "NOT_KNOWN",
  MALE = "MALE",
  FEMALE = "FEMALE",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}

export default GenderType;
